import { Api } from '@/src/store/api'

export const CardBenefitsApi = Api.enhanceEndpoints({
  endpoints: {
    'POST /benefits/:benefitName/enroll': {
      invalidatesTags: ['GET /benefits/enrollments'],
    },
    'POST /benefits/referral-bonus/activate': {
      invalidatesTags: ['GET /benefits/enrollments'],
    },
  },
})
